package com.anjuros.website.templates.template4.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template4.modules.Template4Section
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColor
import com.anjuros.website.templates.template4.util.Template4Constants.FONT_FAMILY
import com.anjuros.website.templates.template4.util.Template4ObserverViewportEntered
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template4SectionTitle(
    modifier: Modifier=Modifier,
    section: Template4Section,
    alignment : Alignment.Horizontal=Alignment.Start){

    val scope = rememberCoroutineScope()
    var titleMargin by remember { mutableStateOf(50.px) }
    var subtitleMargin by remember { mutableStateOf(50.px) }

    Template4ObserverViewportEntered(
        sectionId = section.id,
        distanceFromTop = 300.0,
        onViewportEnteredLambda = {
            scope.launch {
               subtitleMargin=0.px
               if(alignment==Alignment.Start){
                   delay(25)
               }
               titleMargin=0.px

            }
        }
    )

    Column(modifier=modifier,
        horizontalAlignment = alignment){


        P(attrs = Modifier
            .fillMaxWidth()
            .margin(
                left =if(alignment==Alignment.Start) subtitleMargin else 0.px,
                right = if(alignment==Alignment.CenterHorizontally) subtitleMargin else 0.px,
                top=0.px,
                bottom = 10.px)
            .textAlign(if(alignment==Alignment.CenterHorizontally) TextAlign.Center else TextAlign.Start)
            .fontFamily(FONT_FAMILY)
            .fontSize(40.px)
            .fontWeight(FontWeight.Bold)
            .color(section.color)
            .transition(Transition.of(property = "margin", duration = 300.ms))
            .toAttrs()) {
            Text(LocalText(section.title))

        }

        Box(modifier=Modifier
            .height(2.px)
            .width(80.px)
            .backgroundColor(Template4Theme.Primary.getColor())
            .borderRadius(r=50.px)){

        }
    }
}